export default __webpack_public_path__ + "static/media/Top_Offer_Mobile_banner.e73ba68f.JPG";